import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

// Create e update vivem no Quarkus (POST/PUT).
export function useSavePatient() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((patient) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = patient.id
      ? quarkusApi.put('/patients', patient, authHeader)
      : quarkusApi.post('/patients', patient, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
